import { makeStyles } from '@material-ui/core';
import { rem } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

const tabFontSize = {
  '@media (max-height: 768px)': {
    fontSize: rem(0.75),
  },
  '@media (max-height: 576px)': {
    fontSize: rem(0.625),
  },
};

interface PassedProps {
  leftHanded?: boolean;
}

export const styles = makeStyles({
  backgroundWhite: {
    backgroundColor: themeColor.white,
  },
  tenderCountContainer: {
    backgroundColor: themeColor.white,
    padding: `0 .75vw`,
    flexWrap: 'nowrap',
    overflow: 'hidden'
  },
  tenderCountContent: {
    height: '89.9vh',
    width: '100%',
    alignContent: 'flex-start',
    padding: `1.3vh 0`,
  },

  tenderCountScrollContainer: {
    height: 0,
    flexGrow: 1,
  },
  tenderCountScrollButtonContainer: {
    height: '7.3vh',
  },
  tenderCountControlContainer: (props: PassedProps) => ({
    paddingBottom: '.75vh',
    paddingLeft: props.leftHanded ? 0 : '1.3vw',
    paddingRight: props.leftHanded ? '1.3vw' : 0,
  }),
  tenderGroupTabContainer: {
    height: '76.7vh',
    paddingBottom: 10,
  },
  cancelButton: {
    fontSize: rem(1),
    marginLeft: '.75vw',
    ...tabFontSize,
    '@media (max-width: 1024px)': {
      width: '10vw',
    },
    '@media (max-width: 800px)': {
      fontSize: `${rem(0.55)} !important`,
    },
  },
  submitTenderCountButton: {
    '@media (max-width: 1024px)': {
      width: '10vw',
      whiteSpace: 'pre',
    },
    '@media (max-width: 800px)': {
      fontSize: `${rem(0.55)} !important`,
    },
    fontSize: rem(1),
    marginLeft: '.75vw',
    marginRight: '.75vw',
    flexGrow: 1,
    backgroundColor: `${themeColor.secondaryContrast} !important`,
    '&:hover': {
      backgroundColor: `${themeColor.secondaryContrastActive} !important`,
      boxShadow: 'none !important',
    },
    color: themeColor.almostblack,
    ...tabFontSize,
  },
});
